import { useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { LogoBox } from '../../components/Logo/Logo'
import { AuthorizationBox } from '../../components/AuthorizationBox/AuthorizationBox'
import { ResetPasswordBox } from '../../components/ResetPasswordBox/ResetPasswordBox'
import { RegistrationBox } from '../../components/RegistrationBox/RegistrationBox'
import { banner_loader } from '../../common/svg_img'
import { BarLoader } from 'react-spinners';
import { TitlePage } from '../../components/TitlePage/TitlePage'
import "./AuthorizationPage.scss"

const AuthorizationPage = () => {
    const [loading, setLoading] = useState(false)
    const [requestError, setRequestError] = useState(false)

    return (
        <div className='autorization__content'>
            {
                !loading ?
                    <>
                        <header className='autorization__header'>
                            < LogoBox stopRedirect />
                        </header>

                        <Routes>
                            <Route path='*' element={< AuthorizationBox setLoading={e => setLoading(e)} requestError={requestError} setRequestError={e => setRequestError(e)} />} />
                            <Route path='/signup/*' element={< RegistrationBox />} />
                            <Route path='reset-password/:id' element={< ResetPasswordBox />} />
                        </Routes>
                    </>
                    :
                    <div className="main-loader-box">
                        <embed className='main-loader-box__img' type='image/svg+xml' src={banner_loader} />
                        <TitlePage title='Загружаем данные' />
                        <div className='main-loader-box__progress'>
                            <BarLoader
                                color="#27BC62"
                                height='24'
                                width='100%'
                                speedMultiplier={1} />
                        </div>
                    </div>
            }
        </div>
    )
}

export { AuthorizationPage }